import axios from 'axios';
import React, { useState } from 'react'

export default function SearchBar({ data, setResult, setPending, setTotalRows, setPerPage }) {
    const handleSearch = (e) => {
        const value = (e.target.value).toUpperCase()

        const result = data?.filter(x => x.productName?.toUpperCase()?.includes(value) || x.productCode?.includes(value) || x.model?.toUpperCase()?.includes(value)
            || x.orderDate?.includes(value) || x.ordersCode?.includes(value) || x.customer?.includes(value) || x.tel?.includes(value) || x.note?.toUpperCase()?.includes(value)
            || x.status?.toUpperCase()?.includes(value) || x.sales?.toUpperCase()?.includes(value) || x.trackingNumber?.includes(value) || x.social?.includes(value))
        setResult(result)
    }

    return (
        // <div style={{display:"flex", justifyContent:"center" }} className='w-full'>
        <>
            {data && <div className='relative'>
                <input type='text' placeholder='SearchBar' style={{ borderRadius: "20px", width: "300px" }} onChange={handleSearch} />
                <i className="absolute mt-3 fas fa-search" style={{ marginLeft: "-35px" }}></i>
            </div>}
            
        </>

    )
}
